import React from 'react';
import {
    Box,
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    LinearProgress,
} from '@material-ui/core';
import { Field, Form, Formik } from 'formik';
import Spin from 'components/atoms/Spin/Spin';
import FormikTextField from '../../components/atoms/FormikInput/FormikInput';
import { useCourierLogic } from '../../components/organisms/Couriers/useCourierLogic';
import { CourierInfo } from '../../components/molecules/CourierInfo';
import { CourierRegType } from '../../api/couriers';
import CourierEditDialog from '../../components/organisms/CourierEditDialog/CourierEditDialog';

const CourierActivation = () => {
    const {
        loading,
        confirmLoading,
        handleOpenDialog,
        handleReject,
        handleInstructed,
        handleBack,
        photos,
        instructed,
        request,
        personnelForm,
        personnelOpen,
        setPersonnelOpen,
        classes,
        handleActivate,
        personnelFormValidScheme,
        load,
        courierFormOpen,
        setCourierFormOpen,
        handleCloseCourierForm,
    } = useCourierLogic(true);

    const user = request?.courier?.user;
    const courier = request?.courier;

    return (
        <Box className={classes.root}>
            <Button onClick={handleBack}>Назад</Button>

            {loading && <Spin variant="inline" />}
            {!loading && (
                <Box marginTop={3} marginLeft={1}>
                    <CourierInfo
                        type={CourierRegType.Activation}
                        user={user}
                        courier={courier}
                        photos={photos}
                        handleEdit={() => {
                            setCourierFormOpen(true);
                        }}
                    />
                    <Box marginTop={1}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    color="primary"
                                    checked={instructed}
                                    onChange={handleInstructed}
                                />
                            }
                            label="Курьер прошел обучения"
                        />
                    </Box>
                    <Box className={classes.buttons}>
                        <div className={classes.progress}>
                            {confirmLoading && <LinearProgress />}
                        </div>
                        <Button
                            disabled={!instructed}
                            color="primary"
                            variant="contained"
                            onClick={handleOpenDialog}
                        >
                            Активировать
                        </Button>
                        <Button color="secondary" variant="contained" onClick={handleReject}>
                            Отклонить
                        </Button>
                    </Box>
                </Box>
            )}
            <Dialog open={personnelOpen} fullWidth={true} onClose={() => setPersonnelOpen(false)}>
                <Formik
                    enableReinitialize={true}
                    initialValues={personnelForm}
                    validationSchema={personnelFormValidScheme}
                    onSubmit={(values, { setSubmitting }) => {
                        handleActivate(values.personnelNumber, setSubmitting);
                    }}
                >
                    {({ isSubmitting }) => (
                        <Form>
                            <DialogTitle>Табельный номер</DialogTitle>
                            <DialogContent>
                                <Box display="flex" flexDirection="column">
                                    <Field
                                        component={FormikTextField}
                                        name="personnelNumber"
                                        label="Введите табельный номер курьера"
                                    />
                                </Box>

                                {isSubmitting && <LinearProgress />}
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => setPersonnelOpen(false)}>Отмена</Button>
                                <Button type={'submit'}>Ок</Button>
                            </DialogActions>
                        </Form>
                    )}
                </Formik>
            </Dialog>
            {courierFormOpen && (
                <CourierEditDialog
                    courier={courier}
                    open={courierFormOpen}
                    load={load}
                    onClose={handleCloseCourierForm}
                />
            )}
        </Box>
    );
};

export default CourierActivation;
